export default tabler;
export {format};

const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

const format = {
  percentile(i) {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + "st";
    }
    if (j == 2 && k != 12) {
      return i + "nd";
    }
    if (j == 3 && k != 13) {
      return i + "rd";
    }
    return i + "th";
  },

  earnings(i) {
    return "$" + i.toFixed(2).toLocaleString("en-US");
  },

  percent(i) {
    return i.toFixed(2) + "%";
  },
};

/**
 * Format json data rows as html table
 *
 * @param {Array} keys array of keys for table columns in data array
 * @param {Array} data json data formatted [x: x.val, y: y.val],
 * @returns {HTMLElement} Table element containing passed data
 */
function tabler(keys, data, sr, caption) {
  const table = document.createElement("table");
  table.classList.add("table");
  if (sr == true) {table.classList.add("sr-only")}
  const cap = document.createElement("caption");
  const heading = document.createElement("thead");
  const body = document.createElement("tbody");
  const headRow = document.createElement("tr");

  cap.innerText = caption;

  keys.forEach((key) => {
    let header = document.createElement("th");
    header.innerText = capitalize(key);
    headRow.appendChild(header);
  });

  heading.appendChild(headRow);

  data.forEach((element) => {
    let row = document.createElement("tr");
    keys.forEach((el) => {
      let cell = document.createElement("td");
      if (el in format) {
        cell.innerText = format[el](element[el]);
      } else {
        cell.innerText = element[el];
      }
      row.appendChild(cell);
    });
    body.appendChild(row);
  });

  table.appendChild(cap);
  table.appendChild(heading);
  table.appendChild(body);

  return table;
}
